import React from 'react';
import Marker from 'src/components/YandexMap/components/Marker';
import { loadReactComponent } from 'src/components/YandexMap/loaders/componentLoaders';
import { loadModulePromise } from 'src/components/YandexMap/mapLoader';
import type { Coordinates } from 'src/components/YandexMap/types';

const YMapLayer = loadReactComponent('YMapLayer', loadModulePromise);

type HotelLayerProps = {
  coordinates: Coordinates;
};

export const HotelLayer = (props: HotelLayerProps) => {
  const { coordinates } = props;

  return (
    <>
      <YMapLayer type="markers" />
      <Marker coordinates={coordinates} />
    </>
  );
};
